module.exports = __webpack_public_path__ + "static/2021_USL_Collective_Bargaining_Agreement-5f2880735ea72eac9bdfcf7ce89b125c.pdf";